export default __webpack_public_path__ + "static/media/phil.a54bebbd.png";